export enum SuggestType {
  HISTORY = "history",
  SUGGEST = "suggest",
  TRENDING_QUERY = "trendingQuery",
  CLOSED = "closed"
}
